<kt-base-modal [title]=" functionlity + ' Shift'">

  <div modal-body>
    <kt-loader [showLoader]="loading()">
      <div #wizard class="kt-grid kt-wizard-v1 kt-wizard-v1--white start-shift-container" id="kt_wizard_v1">
        <!--begin: Form Wizard Nav -->
        <div class="kt-grid__item kt-wizard-v1__nav-items--clickable">
          <div class="kt-wizard-v1__nav">
            <div class="kt-wizard-v1__nav-items">
              <div class="kt-wizard-v1__nav-item" *ngIf="showPhotoStep" data-ktwizard-type="step"
                data-ktwizard-state="pending">
                <div class="kt-wizard-v1__nav-body">
                  <div class="kt-wizard-v1__nav-label">
                    Photo
                  </div>
                </div>
              </div>
              <div class="kt-wizard-v1__nav-item" *ngIf="showFillformStep" data-ktwizard-type="step"
                data-ktwizard-state="pending">
                <div class="kt-wizard-v1__nav-body">
                  <div class="kt-wizard-v1__nav-label">
                    Form
                  </div>
                </div>
              </div>
              <div class="kt-wizard-v1__nav-item" data-ktwizard-type="step" data-ktwizard-state="pending">
                <div class="kt-wizard-v1__nav-body">
                  <div class="kt-wizard-v1__nav-label">
                    Verify
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!--end: Form Wizard Nav -->
        <div class="kt-grid__item kt-grid__item--fluid kt-wizard-v1__wrapper">
          <!--begin: Form Wizard Form-->
          <div class="kt-form" id="kt_form">
            <!--begin: Form Wizard Step 1 (client)-->
            <div class="kt-wizard-v1__content start-shift-scroll" *ngIf="showPhotoStep"
              data-ktwizard-type="step-content" data-ktwizard-state="pending">
              <div class=" d-flex flex-column justify-content-center align-items-center m-3" style="min-height: 200px;">
                <webcam [mirrorImage]="'never'" [height]="300" [imageQuality]="0.5"
                  (imageCapture)="onCamSuccess($event)" [trigger]="triggerObservable"
                  *ngIf="!webCamImageUrl() && cameraAccess" [allowCameraSwitch]="true" (initError)="errorHandler($event)">
                </webcam>

                <br />
                <div>
                  <img *ngIf="webCamImageUrl()" [src]="webCamImageUrl()" height="300">
                </div>
                <button class="btn btn-sm btn-primary mt-2" *ngIf="!webCamImageUrl() && cameraAccess"
                  (click)="triggerSnapshot()">Capture</button>
                <button class="btn btn-sm btn-primary mt-2" *ngIf="webCamImageUrl() && cameraFound"
                  (click)="resetClickHandler()">Reset</button>

                <div class="text-danger" *ngIf="!cameraAccess">
                  Camera access is required. Please allow camera access to proceed.
                  <a href="javascript:;" (click)="resetClickHandler()">Retry</a>
                </div>
                <div [hidden]="webCamImageUrl() && cameraAccess && cameraFound">Please capture the picture</div>


              </div>

            </div>

            <!--begin: Form Wizard Step 2 (area)-->
            <div class="kt-wizard-v1__content start-shift-scroll" *ngIf="showFillformStep"
              data-ktwizard-type="step-content" data-ktwizard-state="pending">
              <div class="kt-form__section" style="min-height: 300px;">
                <div class="h5 bg-light p-3 my-3 d-flex justify-content-between align-items-center">
                  <div>
                    Please Fill the form <strong> {{form.form_name}}</strong>
                  </div>
                  <div>
                    <button type="button" *ngIf="!formFilled()" class="btn btn-sm btn-label-danger btn-bold"
                      (click)="formFillClickHandler()">
                      <span class="p-3"> Fill</span>
                    </button>
                    <button type="button" *ngIf="formFilled()" class="btn btn-sm btn-label-success btn-bold"
                      (click)="formFillClickHandler()">
                      <span class="p-3"> Filled</span>
                    </button>
                    <button type="button" *ngIf="formFilled()" class="btn btn-sm btn-clean btn-icon btn-icon-sm ms-3"
                      (click)="formFillClickHandler()">
                      <svg-icon class=" d-inline" src="assets/media/iq-svg/without_circle/icon_set_3/edit.svg"></svg-icon>
                    </button>
                  </div>
                </div>
              </div>
            </div>
            <!--end: Form Wizard Step 2 -->

            <!--begin: Form Wizard Step 3 (client)-->
            <div class="kt-wizard-v1__content start-shift-scroll" data-ktwizard-type="step-content"
              data-ktwizard-state="pending">
              <div class="h5 text-center bg-light p-3 my-3">
                Distance From Actual Location {{distanceFromActualLocation | number : '1.2-2' }} KMs
              </div>
              <div class="row">
                <div class="col-xl-6 form-group">
                  <google-map *ngIf="mapReady() && location.latitude" class="kt-map d-block w-100" width="100%"
                    height="400px" [center]="{ lat: location.latitude, lng: location.longitude }" [zoom]="18"
                    [options]="{ streetViewControl: false }">
                    <map-marker #m1="mapMarker" [position]="{ lat: location.latitude, lng: location.longitude }"
                      [options]="{ draggable: false, icon: defaultEnum.LOCATION_ICON_URL, title: 'My Current Location' }"
                      (mapClick)="openInfoWindow(m1, 'My Current Location')">
                    </map-marker>
                    <map-marker #m2="mapMarker" *ngIf="this.shiftAllInfo"
                      [position]="{ lat: (+this.shiftAllInfo.area.area_latitude), lng: (+this.shiftAllInfo.area.area_longitude) }"
                      [options]="{ draggable: false, title: 'Address From Our Database' }"
                      (mapClick)="openInfoWindow(m2, (shiftAllInfo?.area?.area_name || '') + ' ' + (shiftAllInfo?.area?.area_address || ''))">
                    </map-marker>
                    <map-info-window>{{ infoContent }}</map-info-window>
                  </google-map>
                </div>
                <div class="col-xl-6">
                  <div class="kt-form__section" *ngIf=" functionlity === shiftFunctionRef.Start">
                    <kt-shift-details [showExtraDetails]="false"
                      [showDateDetails]="!isUnScheduled || functionlity === shiftFunctionRef.End "
                      [shiftDetails]="shiftDetails" [shiftAllInfo]="shiftAllInfo"></kt-shift-details>
                  </div>
                  <div class="kt-form__section" *ngIf=" functionlity === shiftFunctionRef.End">
                    <kt-actual-shift-details [timesheetDetails]="timesheet" [shiftAllInfo]="shiftAllInfo"></kt-actual-shift-details>
                  </div>
                </div>
                <div class="col-xl-12 mb-2">
                  <textarea class="form-control" [(ngModel)]="comment"
                    [placeholder]="functionlity +  ' Shift Comment'"></textarea>
                </div>
              </div>
            </div>
            <!-- <div class="kt-form__section" *ngIf=" functionlity === shiftFunctionRef.Start">
                <kt-shift-details [showExtraDetails]="false"
                  [showDateDetails]="!isUnScheduled || functionlity === shiftFunctionRef.End "
                  [shiftDetails]="shiftDetails" [shiftAllInfo]="shiftAllInfo"></kt-shift-details>
              </div>
              <div class="kt-form__section" *ngIf=" functionlity === shiftFunctionRef.End">
                <kt-actual-shift-details [timesheetDetails]="timesheet"></kt-actual-shift-details>
              </div> -->
            <!--end: Form Wizard Step 3-->

            <!--begin: Form Actions -->
            <div class="kt-form__actions">
              <span>
                <button *ngIf="showFillformStep || showPhotoStep" class="btn btn-outline-brand" type="button"
                  data-ktwizard-type="action-prev">
                  Previous
                </button>
              </span>
              <button class="btn btn-brand" type="button" data-ktwizard-type="action-next"
                [hidden]="!webCamImageUrl() && showPhotoStep">
                Next
              </button>
              <button *ngIf="isLastStep" (click)="saveClickHandler()" class="btn btn-brand " type="button">
                Submit
              </button>

            </div>

            <!--end: Form Actions -->
          </div>

          <!--end: Form Wizard Form-->
        </div>

      </div>
    </kt-loader>
  </div>

</kt-base-modal>